module.exports = __webpack_public_path__ + "img/grid_image.faaed0ce.jpeg";